<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps({
  isBackgroundTransparent: {
    type: Boolean,
    default: false
  }
});

const backgroundClass = computed(() => {
  if (props.isBackgroundTransparent) {
    return "bg-transparent";
  }

  return "bg-background";
});
</script>

<template>
  <div
    class="d-flex flex-column min-vh-100 main-container"
    :class="backgroundClass"
  >
    <div class="main-content">
      <RouterView />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main-container {
  max-width: 768px;
  margin: 0 auto;

  .main-content {
    min-height: inherit;
  }
}
</style>
